module.exports = __webpack_public_path__ + "img/创建标签2.39ad90af.svg";